<div >

  <h2 class="col-12">Confirmer l'annulation</h2>
  <h3 class="col-12">{{book.station_name}}</h3>
  <div class="col-12">
    <div class="row">
      <div class="col-4">
        <label>
          <mat-icon aria-hidden="false" aria-label="Example home icon">today</mat-icon>
          Début de reservation
        </label>
      </div>
      <div class="col-4">
      </div>
      <div class="col-4">
        <label>
          <mat-icon aria-hidden="false" aria-label="Example home icon">today</mat-icon>
          Fin de reservation
        </label>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="row">
      <div class="col-4">
        <label>
          {{start | date:"dd/MM/yyyy HH:mm"}}
        </label>
      </div>
      <div class="col-4">
        <mat-icon aria-hidden="false" aria-label="Example home icon">trending_flat</mat-icon>
      </div>
      <div class="col-4">
        <label>
            {{end | date:"dd/MM/yyyy HH:mm"}}
          </label>
      </div>
    </div>
  </div>

  <div class="col-12">
    <label>
      <mat-icon aria-hidden="false" aria-label="Example home icon">credit_card</mat-icon>
      Prix de la réservation : {{book.price}}
    </label>
  </div>
  <div class="col-12">
    <div class="row justify-content-around">
      <button class="col-sm-4 align-self-end" color="primary" mat-stroked-button (click)="cancel()">Retour</button>
      <button class="col-sm-4 align-self-end" color="primary" mat-flat-button (click)="confirm();">Confirmer</button>
    </div>
  </div>
</div>
<ng-template #loadExtend></ng-template>
